@if (session$ | async; as session) {
  @if (session.retakeRequest?.retakenAt) {
    <lv-retake-request-submitted
      [session]="session"
      [retakeRequest]="session.retakeRequest"
      [identification]="session.activeIdentification"
    ></lv-retake-request-submitted>
  } @else {
    <lv-session-retake-request-form
      [token]="token"
      [session]="session"
      [retakeRequest]="session.retakeRequest"
    ></lv-session-retake-request-form>
  }
}
